export interface RelatedSortableRow {
  catalogItemId?: string | null;
  itemName?: string | null;
  expirationDate?: string | null;
  expectedExpirationDate?: string | null;
  startingExpirationDate?: string | null;
  observedExpirationDate?: string | null;
}

function normalizedText(value: string | null | undefined): string {
  return (value ?? "").trim();
}

function displayExpiration(row: RelatedSortableRow): string {
  return normalizedText(row.observedExpirationDate) || normalizedText(row.startingExpirationDate) || normalizedText(row.expectedExpirationDate) || normalizedText(row.expirationDate);
}

export function sortRowsForRelatedDisplay<T extends RelatedSortableRow>(rows: T[]): T[] {
  return rows
    .map((row, index) => ({ row, index }))
    .sort((a, b) => {
      const nameCompare = normalizedText(a.row.itemName).localeCompare(normalizedText(b.row.itemName));
      if (nameCompare !== 0) return nameCompare;

      const catalogCompare = normalizedText(a.row.catalogItemId).localeCompare(normalizedText(b.row.catalogItemId));
      if (catalogCompare !== 0) return catalogCompare;

      const expirationCompare = displayExpiration(a.row).localeCompare(displayExpiration(b.row));
      if (expirationCompare !== 0) return expirationCompare;

      return a.index - b.index;
    })
    .map((entry) => entry.row);
}
